module.exports = __webpack_public_path__ + "static/media/china.bd589ceb.jpg";